import {
    COUPON_CHECK_INIT,
    COUPON_CHECK_SUCCESS,
    COUPON_CHECK_FAILURE,
    COUPON_CLEAR,
    COUPON_STATUS_PENDING,
    COUPON_STATUS_FAILURE,
} from '../actions/CouponActions';

const initialState = {
    code: '',
    status: null, // PENDING | SUCCESS | FAILURE | null
    data: null,   // upstream payload: {isValid, type, discount, name, ...}
};

export default function CouponReducer(state = initialState, action) {
    switch (action.type) {
        case COUPON_CHECK_INIT:
            return {
                ...state,
                code: action.payload.code || '',
                status: COUPON_STATUS_PENDING,
                data: null,
            };

        case COUPON_CHECK_SUCCESS:
            return {
                code: action.payload.code,
                status: action.payload.status,
                data: action.payload.data,
            };

        case COUPON_CHECK_FAILURE:
            return {
                code: action.payload.code || '',
                status: COUPON_STATUS_FAILURE,
                data: null,
            };

        case COUPON_CLEAR:
            return initialState;

        default:
            return state;
    }
}
